import React, { Component } from "react";
import { Link } from "react-router-dom";
import calcularPx from "../calcularPx.js";
import { ReactComponent as IcoLogout } from "../../../res/iconos/logout.svg";

class RegionDesktop extends Component {
  state = { nivel: this.props.nivelLogin };

  componentDidUpdate(prevProps) {
    if (prevProps.nivelLogin != this.props.nivelLogin) {
      this.setState({ nivel: this.props.nivelLogin });
    }
  }

  render() {
    return (
    <div 
      style={
      {
        position: "absolute",
        marginLeft: -100+12.5,
        //marginRight: "auto",
        top: calcularPx(102),
        width: 200,
        height: "auto",
        display: "flex",
        justifyContent: "space-between",
        background: "#FFFFFF",
        paddingLeft: 30,
        paddingTop: 30,
        paddingBottom: 30,
        paddingRight: 30,
        borderBottomLeftRadius: 25,
        borderBottomRightRadius: 25,
        borderBottom: "solid",
        borderBottomWidth: 1,
        borderBottomColor: "#e5e8e9",
        borderLeft: "solid",
        borderLeftWidth: 1,
        borderLeftColor: "#e5e8e9",
        borderRight: "solid",
        borderRightWidth: 1,
        borderRightColor: "#e5e8e9"
      }}
    >
        <div>          
          <button
            className="categoria_submenu"
            style={{
              textAlign: "left",
              width: "100%",
              border: "none",
              background: "transparent",
            }}
            onClick={() => {
              this.props.ocultar();
              this.props.setRegion("ar");
            }}
          >
            <img 
              src={require(`../../../res/iconos/region_ar.png`)} 
              style={{ marginRight: 15 }}
              width={25}
              height={25}
            />
            Argentina
          </button>
          <div style={{width: "100%", height: 10}}/>
          <button
            className="categoria_submenu"
            style={{
              textAlign: "left",
              width: "100%",
              border: "none",
              background: "transparent",
            }}
            onClick={() => {
              this.props.ocultar();
              this.props.setRegion("cl");
            }}
          >
            <img 
              src={require(`../../../res/iconos/region_cl.png`)} 
              style={{ marginRight: 15 }}
              width={25}
              height={25}
            />
            Chile
          </button>
          <div style={{width: "100%", height: 10}}/>
          <button
            className="categoria_submenu"
            style={{
              textAlign: "left",
              width: "100%",
              border: "none",
              background: "transparent",
            }}
            onClick={() => {
              this.props.ocultar();
              this.props.setRegion("bo");
            }}
          >
            <img 
              src={require(`../../../res/iconos/region_bo.png`)} 
              style={{ marginRight: 15 }}
              width={25}
              height={25}
            />
            Bolivia
          </button>
          <div style={{width: "100%", height: 10}}/>
          <button
            className="categoria_submenu"
            style={{
              textAlign: "left",
              width: "100%",
              border: "none",
              background: "transparent",
            }}
            onClick={() => {
              this.props.ocultar();
              this.props.setRegion("mx");
            }}
          >
            <img 
              src={require(`../../../res/iconos/region_mx.png`)} 
              style={{ marginRight: 15 }}
              width={25}
              height={25}
            />
            México
          </button>
        </div>      
    </div>)
  };
};

export default RegionDesktop;
